<template>
  <div>
    <v-overlay
      v-model="showDeleteSuccess"
      :scrim="true"
      opacity="0.3"
      persistent
      :z-index="9999"
    >
    </v-overlay>
    <transition name="fade-slide">
      <output v-if="showDeleteSuccess" class="success-toast">
        <img src="@/assets/mdi_success-bold.svg" alt="img" width="20" height="20" />
        <span style="font-size: 14px; font-weight: 600;">{{ deleteSuccessMessage }}</span>
      </output>
    </transition>
    <v-container fluid>
      <v-card class="card2" style="margin-top: 1rem">
        <v-card-text>
          <v-row align="center" style="margin-top: -20px;">
            <v-col cols="12" md="6">
              <h2 style="font-weight: 600; color: #171717;">{{ $t('intentGroupList') }}</h2>
            </v-col>
            <v-col cols="6" class="d-flex flex-wrap justify-end gap-2">
              <v-row align="center" justify="end" style="gap: 20px;">
                <v-text-field
                  v-model="searchName"
                  :placeholder="$t('intentGroupName')"
                  hide-details
                  variant="plain"
                  class="search-input"
                  density="comfortable"
                  @input="onSearchInput"
                  @click:clear="clearSearch"
                >
                  <template #prepend-inner>
                    <img
                      class="search-icon"
                      src="@/assets/flowbite_search-outline.svg"
                      alt="Search"
                      width="20"
                      height="20"
                    />
                  </template>
                </v-text-field>
                <v-tooltip location="top" max-width="230px">
                  <template v-slot:activator="{ props }">
                    <button
                      v-bind="props"
                      id="button-add-intentgroup"
                      type="button"
                      class="products-header-button"
                      variant="elevated"
                      size="large"
                      rounded="xl"
                      @click="Add()"
                    >
                      <img src="@/assets/ic_round-plus.svg" alt="img" width="20" height="20" />
                      <span style="color: #ffffff; font-size: 14px;">{{ $t("add") }}</span>
                    </button>
                  </template>
                  <span>{{ $t('addNewIntentGroup') }}</span>
                </v-tooltip>
              </v-row>
            </v-col>
          </v-row>
        </v-card-text>
        <v-data-table-server
          v-model:options="options"
          :items-per-page="itemsPerPage"
          :items-length="searchTotalTable"
          :items="dataTable"
          :headers="headers"
          :loading="loadingTable"
          class="pa-4"
        >
          <template #no-data>
            <div style="text-align: center;">
              <span style="color: #646464; font-weight: 400;">{{ $t('noDataAvailable') }}</span>
            </div>
          </template>
          <template v-slot:bottom>
            <div
              class="d-flex justify-space-between align-center px-4 py-2"
              style="width: 100%"
            >
              <div>{{ $t('totalResults') }} {{ searchTotalTable }}</div>

              <v-data-table-footer
                :items="[
                  { text: '10', value: 10 },
                  { text: '25', value: 25 },
                  { text: '50', value: 50 },
                  { text: '100', value: 100 },
                  { text: 'All', value: -1 },
                ]"
                :page="options.page"
                :length="Math.ceil(searchTotalTable / itemsPerPage)"
              />
            </div>
          </template>

          <template v-slot:item="{ item }">
            <tr style="color: #000000; font-weight: 500; font-size: 13px;">
              <td style="text-align: left">{{ item.number }}</td>
              <td>{{ item.name }}</td>
              <td>{{ substring(item.intentSessionName) }}</td>
              <td style="text-align: left">{{ item.createBy }}</td>
              <td style="text-align: left">
                <div class="action-group" style="justify-content: center;">
                  <!-- Edit -->
                  <v-btn
                    id="button-edit-intentgroup" 
                    variant="text"
                    density="comfortable"
                    @click="Edit(item)"
                    icon
                  >
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/Edit.svg"
                          alt="img"
                          width="20"
                          height="20"
                          style="cursor: pointer; margin-left: 4px;"
                        />
                      </template>
                      <span>{{ $t('edit') }}</span>
                    </v-tooltip>
                  </v-btn>
                  <!-- Custom Divider -->

                  <!-- Delete -->
                  <v-btn
                    id="button-delete-intentgroup"
                    variant="text"
                    density="comfortable"
                    @click="openDeleteDialog(item)"
                    icon
                    :disabled="btnDisableDelete(item)"
                  >
                    <v-tooltip location="top" max-width="230px">
                      <template v-slot:activator="{ props }">
                        <img
                          v-bind="props"
                          src="@/assets/Group.svg"
                          alt="img"
                          width="20"
                          height="17"
                          style="cursor: pointer; margin-left: 4px;"
                        />
                      </template>
                      <span>{{ $t('delete') }}</span>
                    </v-tooltip>
                  </v-btn>
                </div>
              </td>
            </tr>
          </template>
        </v-data-table-server>

        <v-dialog v-model="showDeleteDialog" max-width="570">
          <v-card class="delete-dialog-card">
            <v-card-title class="card-dialog-title" style="background-color: #FFF2F2;">
              <span class="dialog-title font-weight-bold">{{ $t('deleteIntentGroup') }}</span>
              <v-btn icon variant="text" density="comfortable" @click="closeDeleteDialog">
                <img src="@/assets/Vector.svg" alt="icon" width="12" height="12">
              </v-btn>
            </v-card-title>
            <v-divider></v-divider>
            <v-card-text class="pt-6 pb-4 px-4 body-text">
              {{ $t('_confirmDeleteIntentGroup') }}
            </v-card-text>
            <hr style="border: none; border-top: 1px solid #c9c9c9;" />
            <v-card-actions class="px-6 pb-3 pt-3 pl-8 justify-end" style="gap: 12px;">
              <button type="button" class="cancel-btn" @click="closeDeleteDialog" :disabled="deleting">{{ $t('cancel') }}</button>
              <v-btn class="delete-confirm-btn" :loading="deleting" @click="Delete(item.intentGroupID)">
                <img src="@/assets/heroicons_trash-solid.svg" alt="img" width="17" height="22" class="mr-2">
                <p style="color: #ffffff; font-size: 11px; font-weight: 500;">{{ $t('delete') }}</p>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>

      </v-card>
    </v-container>
    <v-overlay :model-value="dialog" class="align-center justify-center" persistent>
      <v-card class="loading-card" elevation="8">
        <v-card-text class="text-center">
          <v-progress-circular
            indeterminate
            size="64"
            color="primary"
            class="mb-4"
          ></v-progress-circular>
          <h3 class="loading-title">{{ $t('loading') }}</h3>
          <p class="loading-subtitle">{{ $t('pleaseWait') }}</p>
        </v-card-text>
      </v-card>
    </v-overlay>
    <!-- Edit -->
    <v-dialog v-model="EditIntentGroup" max-width="1000">
      <v-card>
        <v-card-title class="text-h5 grey lighten-2">
          {{ $t("edit") }}
        </v-card-title>
        <v-card-text style="margin-top: 1rem">
          <v-row>
            <v-col cols="12" sm="12" md="4">
              <v-text-field
                id="groupintentname-edit-intentgroup"
                :label="$t('groupIntentName')"
                v-model="GroupIntent.Name"
                :rules="[rules.required]"
                required
                outlined
                dense
              >
                <template v-slot:append-outer>
                  <v-tooltip location="top" max-width="300">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        text
                        x-small
                        style="position: absolute; top: 0px; right: -6px"
                        v-bind="props"
                        >mdi-information-outline</v-icon
                      >
                    </template>
                    <span>{{ $t("_InfoGroupModelName") }}</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row style="margin-top: 0">
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                id="edit-model-intentgroup"
                :label="$t('model')"
                v-model="GroupIntent.IntentSession"
                :items="DDIntentSession"
                item-title="name"
                item-value="id"
                chips
                clearable
                deletable-chips
                multiple
                outlined
              >
                <template v-slot:append-outer>
                  <v-tooltip location="top" max-width="300">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        text
                        x-small
                        style="position: absolute; top: 0px; right: -6px"
                        v-bind="props"
                        >mdi-information-outline</v-icon
                      >
                    </template>
                    <span>{{ $t("_InfoModelinGroup") }}</span>
                  </v-tooltip>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            id="button-close-edit-intentgroup"
            color="blue darken-1"
            variant="text"
            @click="EditIntentGroup = false"
            >{{ $t("close") }}</v-btn
          >
          <v-btn
            id="button-save-edit-intentgroup"
            color="blue darken-1"
            variant="text"
            @click="Save()"
            >{{ $t("save") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Add -->
    <v-dialog v-model="AddIntentGroup" max-width="1000">
      <v-card>
        <v-card-title
          class="text-h5 grey lighten-2"
          style="position: sticky; top: 0px"
        >
          {{ $t("add") }}
        </v-card-title>
        <v-card-text style="margin-top: 1rem">
          <v-row>
            <v-col cols="12" sm="12" md="4">
              <v-text-field
                id="groupintentname-add-intentgroup"
                :label="$t('groupIntentName')"
                v-model="GroupIntent.Name"
                :rules="[rules.required]"
                required
                outlined
                dense
              >
                <template v-slot:append-outer>
                  <v-tooltip location="top" max-width="300">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        text
                        x-small
                        style="position: absolute; top: 0px; right: -6px"
                        v-bind="props"
                        >mdi-information-outline</v-icon
                      >
                    </template>
                    <span>{{ $t("_InfoGroupModelName") }}</span>
                  </v-tooltip>
                </template>
              </v-text-field>
            </v-col>
          </v-row>
          <v-row style="margin-top: 0;">
            <v-col cols="12" sm="12" md="12">
              <v-autocomplete
                id="add-model-intentgroup"
                :label="$t('model')"
                v-model="GroupIntent.IntentSession"
                :items="DDIntentSession"
                item-text="name"
                item-value="id"
                chips
                clearable
                deletable-chips
                multiple
                outlined
                :rules="[rules.required]"
                required
                dense
              >
                <template v-slot:append-outer>
                  <v-tooltip location="top" max-width="300">
                    <template v-slot:activator="{ props }">
                      <v-icon
                        text
                        x-small
                        style="position: absolute; top: 0px; right: -6px"
                        v-bind="props"
                        >mdi-information-outline</v-icon
                      >
                    </template>
                    <span>{{ $t("_InfoModelinGroup") }}</span>
                  </v-tooltip>
                </template>
              </v-autocomplete>
            </v-col>
          </v-row>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            id="button-close-add-intentgroup"
            color="blue darken-1"
            variant="text"
            @click="AddIntentGroup = false"
            >{{ $t("close") }}</v-btn
          >
          <v-btn
            id="button-save-add-intentgroup"
            color="blue darken-1"
            variant="text"
            @click="Save()"
            >{{ $t("save") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import checkPermissionTwo from "@/api/function.js";
import editImg from "@/assets/edit1.png";
import deleteImg from "@/assets/delete1.png";
export default {
  name: "IntentGroup",
  inject: [
    "flagNav",
    "FontColorTitle",
    "SubNavbarBackGround",
    "Username",
    "RoleId"
  ],
  components: {},
  mixins: [checkPermissionTwo],
  data() {
    return {
    showDeleteSuccess: false,
    deleteSuccessMessage: '',
    _deleteToastTimer: null,
    showDeleteDialog: false,
    loadingTable: false,
    today: null,
    searchName: null,
    AddIntentGroup: false,
    EditIntentGroup: false,
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [],
    },
    dataTable: [],
    itemsPerPage: 10,
    searchTotalTable: 0,
    totalTable: 0,
    dialog: false,
    DDIntentSession: [],
    images: {
      edit: editImg,
      delete: deleteImg,
    },
    rules: {
      required: (value) => !!value || this.$t("Required"),
    },
    GroupIntent: {
      IntentGroupID: null,
      Name: null,
      IntentSession: null,
    },
    sortBy: [],
    sortDesc: [],
    isFirst: true,
    isSearch: false,
    };
  },
  computed: {
    headers() {
      return [
        { title: this.$t("no"), align: "left", sortable: false, width: "10%" },
        {
          title: this.$t("intentGroupName"),
          value: "Name",
          align: "left",
          sortable: true,
          width: "20%",
          fontWeight: 700,
        },
        {
          title: this.$t("IntentSession"),
          value: "IntentSessionName",
          align: "left",
          sortable: false,
          width: "35%",
          class: "wrap-text",
        },
        {
          title: this.$t("createdBy"),
          value: "CreateBy",
          align: "left",
          sortable: true,
          width: "15%",
        },
        {
          title: this.$t("manage"),
          align: "center",
          sortable: false,
          width: "15%",
        },
      ];
    },
    rangeStart() {
      if (!this.searchTotalTable) return 0;
      return (this.options.page - 1) * this.options.itemsPerPage + 1;
    },
    rangeEnd() {
      if (!this.searchTotalTable) return 0;
      return Math.min(this.options.page * this.options.itemsPerPage, this.searchTotalTable);
    },
    totalPages() {
      return this.searchTotalTable;
    },
  },
  watch: {
    options: {
    handler() {
      this.Get();
    },
    deep: true,
    immediate: true,
  },
  },
  methods: {
    openDeleteDialog(item) {
      this.item = item;
      this.showDeleteDialog = true;
    },
    closeDeleteDialog() {
      if (this.deleting) return;
      this.showDeleteDialog = false;
      this.item = null;
    },
    btnDisableDelete(item) {
      return (this.RoleId == 2 || this.RoleId == 6) && item.createBy != this.Username;
    },
    Search() {
      this.options.page = 1;
      this.Get();
    },
    onSearchInput() {
      this.options.page = 1;
      this.Get();
    },
    clearSearch() {
      this.searchName = null;
      this.options.page = 1;
      this.Get();
    },
    Get() {
      this.loadingTable = true;

      let { page, itemsPerPage, sortBy } = this.options;
      let sortField = null;
      let sortOrder = null;

      if (sortBy && sortBy.length > 0) {
        sortField = sortBy[0].key;
        sortOrder = sortBy[0].order === 'desc';
      }
      let temp = {
        page: this.isSearch ? 1 : page,
        perPage: itemsPerPage == -1 ? this.totalTable : itemsPerPage,
        DataName: this.searchName,
        sortDesc: sortOrder,
        sortBy: sortField,
      };
      this.$call.GetTableIntentGroup(
        temp,
        (dataResponse) => {
          if (dataResponse.status == 0 && dataResponse.data) {
            this.searchTotalTable = dataResponse.data.total;
            this.dataTable = dataResponse.data.data;
            this.totalTable = this.isFirst
              ? dataResponse.data.total
              : this.totalTable;
          } else {
            this.dataTable = [];
            this.searchTotalTable = 0;
            this.totalTable = 0;
          }
          if (this.isFirst) {
            this.GetDDIntentSession();
          }
          this.loadingTable = false;
          this.isSearch = false;
          this.isFirst = false;
        },
        (errorResource) => {
          this.loadingTable = false;
          this.isSearch = false;
          console.error(errorResource);
        }
      );
    },
    async Save() {
      try {
        if (
          this.GroupIntent.Name == "" ||
          this.GroupIntent.Name == null ||
          this.GroupIntent.IntentSession == "" ||
          this.GroupIntent.IntentSession == null
        ) {
          this.$swal.fire({
            icon: "warning",
            title: this.$t("warning"),
            text: this.$t("warningFillAll"),
            showConfirmButton: false,
            timer: 5000,
          });
          return;
        }
        this.dialog = true;
        if (this.AddIntentGroup) {
          await this.$call.CreateIntentGroup(
            this.GroupIntent,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                this.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 5000,
                });
                this.totalTable = this.totalTable + 1;
                this.Get();
                this.AddIntentGroup = false;
              } else if (dataResponse.status == 3) {
                this.$swal.fire({
                  icon: "warning",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 5000,
                });
              }
              this.dialog = false;
            },
            (errorResource) => {
              this.dialog = false;
              this.AddIntentGroup = false;
              console.error(errorResource);
            }
          );
        } else if (this.EditIntentGroup) {
          await this.$call.UpdateIntentGroup(
            this.GroupIntent,
            async (dataResponse) => {
              if (dataResponse.status == 0) {
                this.$swal.fire({
                  icon: "success",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 5000,
                });
                this.Get();
                this.EditIntentGroup = false;
              } else if (dataResponse.status == 3) {
                this.$swal.fire({
                  icon: "warning",
                  title: dataResponse.message,
                  showConfirmButton: false,
                  timer: 5000,
                });
              }
              this.dialog = false;
            },
            (errorResource) => {
              this.dialog = false;
              this.Editdialog = false;
              console.error(errorResource);
            }
          );
        }
      } catch (error) {
        this.LogTrace(error, "DeleteGroup");
      }
    },
    Add() {
      this.GroupIntent.IntentGroupID = null;
      this.GroupIntent.Name = null;
      this.GroupIntent.IntentSession = null;
      this.$router.push({
        name: "IntentSession",
        query: {
          id: null,
        },
      });
    },
    // Edit(item) {
    //   let self = this;
    //   self.EditIntentGroup = true;
    //   self.GroupIntent.IntentGroupID = item.intentGroupID;
    //   self.GroupIntent.Name = item.name;
    //   self.GroupIntent.IntentSession = item.intentSession;
    // },
    Edit(item) {
      this.$router.push({
        name: "IntentSession",
        query: {
          id: item.intentGroupID,
        },
      });
    },
    Delete(id) {
      this.dialog = true;
      this.deleting = true;
      this.$call.DeleteIntentGroup(
        { IntentGroupID: id },
        (dataResponse) => {
          this.dialog = false;
          this.deleting = false;
          this.showDeleteDialog = false;
          if (dataResponse.status == 0) {
            this.deleteSuccessMessage = this.$t('_intentGroupDeleted');
            this.showDeleteSuccess = true;
            clearTimeout(this._deleteToastTimer);
            this._deleteToastTimer = setTimeout(() => {
              this.showDeleteSuccess = false;
            }, 2000);
            this.Get();
          } else if (dataResponse.status == 1) {
            this.$swal.fire({
              icon: "error",
              title: dataResponse.message,
              showConfirmButton: true,
              confirmButtonText: this.$t("gotIt"),
              confirmButtonColor: "#d33",
            });
          }
        },
        (errorResource) => {
          this.dialog = false;
          this.deleting = false;
          console.error(errorResource);
        }
      );
    },
    // Delete(id) {
    //   let self = this;
    //   try {
    //     self.$swal
    //       .fire({
    //         title: this.$t("ConfirmDeletion"),
    //         text: this.$t("confirmDeletionIntentGroup"),
    //         icon: "warning",
    //         showCancelButton: true,
    //         confirmButtonColor: "#3085d6",
    //         cancelButtonColor: "#d33",
    //         confirmButtonText: this.$t("confirm"),
    //         cancelButtonText: this.$t("cancel"),
    //         reverseButtons: false,
    //       })
    //       .then((result) => {
    //         if (result.isConfirmed) {
    //           self.dialog = true;
    //           self.$call.DeleteIntentGroup(
    //             { IntentGroupID: id },
    //             (dataResponse) => {
    //               self.dialog = false;
    //               if (dataResponse.status == 0) {
    //                 self.$swal.fire({
    //                   icon: "success",
    //                   title: dataResponse.message,
    //                   showConfirmButton: false,
    //                   timer: 1500,
    //                 });
    //                 self.Get();
    //               }else if (dataResponse.status == 1) {
    //                 self.$swal.fire({
    //                   icon: "error",
    //                   title: dataResponse.message,
    //                   showConfirmButton: true,
    //                   confirmButtonText: this.$t("gotIt"),
    //                   confirmButtonColor: "#d33",
    //                 });
    //               }
    //             },
    //             (errorResource) => {
    //               self.dialog = false;
    //               console.error(errorResource);
    //             }
    //           );
    //           self.Get();
    //         }
    //       });
    //   } catch (error) {
    //     self.LogTrace(error, "DeleteGroup");
    //   }
    // },
    beforeUnmount() {
      clearTimeout(this._deleteToastTimer);
    },
    GetDDIntentSession() {
      this.loadingTable = true;
      this.$call.DDIntentSession(
        (dataResponse) => {
          if (dataResponse.status == 0) {
            this.DDIntentSession = dataResponse.data;
          } else {
            this.DDIntentSession = [];
          }
          this.loadingTable = false;
        },
        (errorResource) => {
          this.loadingTable = false;
          console.error(errorResource);
        }
      );
    },
  },
  mounted() {
    this.GetDate();
    this.Get();
    
  },
};
</script>
<style scoped>
.success-toast {
  position: fixed;
  top: 12px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(100deg, #1e883d 0%, #135928 100%) !important;
  color: #ffffff;
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.25);
  z-index: 2100;
  width: 50%;
  max-width: 900px;
  min-width: 320px;
  justify-content: center;
  padding: 12px;
  border: 1px solid #ffffff;
  gap: 20px;
  margin-top: 140px;
}
.delete-dialog-card {
  border-radius: 12px !important;
}
.card-dialog-title {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 16px;
}
.dialog-title {
  margin-top: 8px;
  font-size: 16px;
  color: #C30000 !important;
}
.body-text {
  font-size: 12px;
  font-weight: 500;
  line-height: 1.5;
  color: #171717;
}
.cancel-btn {
  border: 1px solid #949AA8;
  border-radius: 12px;
  height: 40px;
  padding: 4px 16px;
}
.delete-confirm-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 14px !important;
  width: 120px;
  background: #C30000;
}
.products-header-button {
  display: flex;
  flex-direction: row;
  background: linear-gradient(100deg, #C32E0E 0%, #F67760 100%) !important;
  border-radius: 12px;
  width: 108px;
  justify-content: center;
  align-items: center;
  gap: 4px;
  padding: 12px;
  margin-right: 16px;
}
.products-header-button:hover {
  background: linear-gradient(100deg, #F36243 0%, #FF8E7A 100%) !important;
}
:deep(.v-data-table-server) {
  border-radius: 12px;
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
:deep(thead) {
  background-color: #FFE4E1 !important;
  padding: 0 8px;
}
.v-table--has-top :deep(.v-table__wrapper) {
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-left .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}
:deep(.v-data-table .v-table__wrapper > table > thead > tr th.v-data-table-column--align-center .v-data-table-header__content span) {
  font-weight: 600;
  font-size: 14px;
}

.items-select :deep(.v-field) { 
  border-radius: 14px;
  margin-right: 6px;
}
.small-select :deep(.v-field) {
  min-height: 30px;
  height: 36px;
  padding: 0 4px;
}
.small-select :deep(.v-field__input) { 
  min-height: 30px; 
}
.items-select :deep(.v-field__input),
.items-select :deep(.v-select__selection-text),
.items-select :deep(.v-list-item-title) {
  font-size: 14px !important;
}
.dropdown-icon { 
  width: 20px;
  height: 20px;
  transition: transform .2s ease;
  margin-right: 4px;
}
.small-select.v-select--active-menu .dropdown-icon { 
  transform: rotate(180deg);
}
.search-input {
  max-width: 280px;
  background: white;
  border: 1px solid #C9C9C9;
  border-radius: 12px;
}
.search-input :deep(.v-field__field) {
  align-items: center;
}
.search-input :deep(input) {
  padding-top: 0 !important;
  padding-bottom: 0 !important;
  line-height: 20px;
  min-height: 40px;
  display: flex;
  align-items: center;
  font-size: 13px;
}
.search-icon {
  margin-left: 12px;
  margin-top: -4px;
  height: 18px;
}
.card2 {
  border: 1px solid #DCDCDC;
  border-radius: 10px !important;
  margin-bottom: 2rem;
  padding-top: 1rem;
  box-shadow: none;
}

.card {
  border-radius: 10px !important;
  margin-bottom: 2rem;
  height: 90vh;
  overflow: auto;
  padding: 0;
}

.flex {
  margin-left: 2rem;
  margin-right: 2rem;
}
.AddColumn:hover {
  background-color: #1976d2 !important;
  color: white !important;
}
:deep(.UploadFile .NoDragDrop button.v-btn) {
  margin: 0px !important;
}
.wrap-text {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
}

:deep(.v-data-table tbody tr) {
  transition: all 0.2s ease;
  border-bottom: 1px solid rgba(0, 0, 0, 0.06);
}

:deep(.v-data-table tbody tr:hover) {
  background: rgba(0, 0, 0, 0.02);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
}

:deep(.v-data-table-header) {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-bottom: 2px solid #dee2e6;
}

:deep(.v-data-table-header th) {
  color: #495057 !important;
  font-weight: 700 !important;
  font-size: 14px !important;
  padding: 1rem !important;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  border-bottom: 2px solid rgba(25, 118, 210, 0.1) !important;
}

:deep(.v-data-table.sorting-loading) {
  position: relative;
  pointer-events: none;
}

:deep(.v-data-table.sorting-loading::after) {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10;
}

/* Enhanced Sorting Indicators */
:deep(.v-data-table-header th.sortable) {
  cursor: pointer;
  transition: all 0.2s ease;
}

:deep(.v-data-table-header th.sortable:hover) {
  background: #f4f8fd;
  color: #155faa !important;
}

:deep(.v-data-table-header th.sorted) {
  background: #e8f1fb;
  color: #145fa9 !important;
}

/* Sorting Animation */
:deep(.v-data-table tbody) {
  transition: opacity 0.3s ease;
}

:deep(.v-data-table.sorting-loading tbody) {
  opacity: 0.6;
}
</style>
